import React, { useMemo, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import NotificationBell from '../components/NotificationBell';
import BackButton from '../components/BackButton';

const logoSrc = (process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/logo.png` : '/logo.png');

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const userName = useMemo(() => {
    const firstName = localStorage.getItem('firstName') || '';
    const lastName  = localStorage.getItem('lastName')  || '';
    return (firstName && lastName) ? `${firstName} ${lastName}` : '';
  }, []);

  const handleSignOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('researcherId');
    localStorage.removeItem('role_id');
    navigate('/login');
  };

  const authRoutes = ['/login', '/register', '/reset-password', '/request-reset-password'];
  const showRight = !authRoutes.includes(location.pathname) && !!localStorage.getItem('token');

  const hideBackOn = ['/dashboard'];
  const showBack = showRight && !hideBackOn.includes(location.pathname);

  return (
    <div className="top-bar" role="banner">
      <div className="left-content">
        <img src={logoSrc} alt="Logo" className="logo" />
        <h1 className="site-title">NECHRs Submission Portal</h1>
      </div>

      <div className="header-back-slot" aria-hidden={!showBack}>
        <BackButton className={`header-back compact ${showBack ? '' : 'is-hidden'}`} />
      </div>

      {showRight && (
        <div className="right-content">
          <div className="header-bell" aria-label="Notifications">
            <NotificationBell />
          </div>

          <span className="greeting">
            <span className="user-name">Hi,</span> <span className="user-name">{userName}</span>
          </span>

          <span className="right-divider" aria-hidden="true" />

          <button
            onClick={handleSignOut}
            className="sign-out-button"
            aria-label="Sign out"
            title="Sign out"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="sign-out-icon">
              <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}

export default Header;
